module.exports = __webpack_public_path__ + "static/media/reginald-s.c8fec187.png";